export default __webpack_public_path__ + "static/media/task.01b11e0d.svg";